import React from 'react';

function CheckSmsIcon() {
  return (
    <svg
      className="absolute hidden w-[18px] h-[18px] -left-[1.5px] -top-[4px] peer-checked:block"
      stroke="darkCyan"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1.5 12L7 18L19.5 2" stroke="#0080A3" strokeWidth="4" />
    </svg>
  );
}

export default CheckSmsIcon;
